export default __webpack_public_path__ + "static/media/home.1783b983.svg";